import * as React from "react";

import logo from "../Images/microsoft-logo.png";

import { getRootUrl } from "../routing";

class NavigationHeader extends React.Component {
    public render() {
        return (
            <a className="logo" href={getRootUrl() || "/"}>
                <img src={logo} aria-label="Microsoft home" alt="Home" />
            </a>
        );
    }
}

export default NavigationHeader;
